import { connect } from 'react-redux';

export const extendedConnect = (mapStateToProps, mapDispatchToProps) => (
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ));
